const PDFValidator = (url: string) => {
  return {
    validUrl: url,
    isEmbeddable: true,
  }
}

export default PDFValidator
